export const categories = [
  {
    slug: 'newborn-care',
    name: '新生儿护理',
    description: '从喂养到睡眠，全面掌握新生儿护理技巧',
    icon: 'ri-heart-pulse-line',
    color: 'primary',
    imageSeq: 'category-newborn',
  },
  {
    slug: 'postpartum-recovery',
    name: '产后恢复',
    description: '科学产后修复，重拾健康与自信',
    icon: 'ri-plant-line',
    color: 'secondary',
    imageSeq: 'category-postpartum',
  },
  {
    slug: 'breastfeeding',
    name: '母乳喂养',
    description: '母乳喂养全攻略，给宝宝最好的营养',
    icon: 'ri-drop-line',
    color: 'accent',
    imageSeq: 'category-breastfeeding',
  },
  {
    slug: 'early-education',
    name: '宝宝早教',
    description: '抓住关键期，科学启蒙每一步',
    icon: 'ri-lightbulb-line',
    color: 'primary',
    imageSeq: 'category-education',
  },
  {
    slug: 'mom-growth',
    name: '妈妈成长',
    description: '育儿路上，别忘了成为更好的自己',
    icon: 'ri-star-line',
    color: 'accent',
    imageSeq: 'category-growth',
  },
];

export const articles = [
  {
    id: 1,
    slug: 'newborn-sleep-guide',
    title: '新生儿睡眠全攻略：从零开始建立健康作息',
    excerpt: '刚出生的宝宝一天要睡16-20个小时，但很多新手妈妈却发现宝宝总是睡不安稳。本文详细讲解如何帮助宝宝建立规律的睡眠习惯。',
    content: `<p>新生儿的睡眠问题是每位新手妈妈都会遇到的挑战。宝宝刚从温暖黑暗的子宫来到这个世界，需要时间来适应昼夜节律。</p>
<h2>新生儿睡眠特点</h2>
<p>新生儿每天需要16-20小时睡眠，但每次睡眠时间较短，通常在2-4小时之间。这是因为他们的胃容量小，需要频繁进食。不要期望新生儿能够睡整夜觉，这是完全正常的生理现象。</p>
<h2>建立良好睡眠习惯的五个方法</h2>
<h3>1. 区分白天和黑夜</h3>
<p>白天保持房间明亮，正常活动声音；晚上保持安静、昏暗的环境。这帮助宝宝逐渐建立昼夜节律。</p>
<h3>2. 建立睡前仪式</h3>
<p>每天晚上固定时间进行洗澡、按摩、换睡衣、喂奶、轻声讲故事等固定流程，让宝宝知道"该睡觉了"。</p>
<h3>3. 学会识别睡眠信号</h3>
<p>当宝宝揉眼睛、打哈欠、变得烦躁时，就是该睡觉的信号。及时响应能让宝宝更容易入睡。</p>
<h3>4. 创造安全的睡眠环境</h3>
<p>保持房间温度适宜（20-22°C），使用睡袋代替松散的被子，确保婴儿床内没有过多物品。</p>
<h3>5. 培养自主入睡能力</h3>
<p>在宝宝困但还醒着时放入婴儿床，让他们学会自己入睡，而不是依赖抱睡或奶睡。</p>
<h2>常见睡眠问题解答</h2>
<p><strong>宝宝白天睡太多晚上不睡怎么办？</strong>可以适当缩短白天的单次小睡时间，增加白天的活动和互动。</p>
<p><strong>宝宝总是需要抱着才能睡？</strong>可以尝试逐步减少抱睡时间，先用包裹式襁褓给予安全感，再慢慢过渡到自主入睡。</p>
<p>记住，每个宝宝都是独特的，找到适合你宝宝的节奏最重要。耐心和一致性是建立良好睡眠习惯的关键。</p>`,
    category: 'newborn-care',
    categoryName: '新生儿护理',
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20newborn%20baby%20sleeping%20soundly%20in%20a%20cozy%20cot%20with%20soft%20warm%20lighting%2C%20gentle%20pastel%20nursery%20decor%2C%20minimal%20and%20clean%20aesthetic%2C%20soft%20focus%2C%20editorial%20photography%20with%20warm%20cream%20and%20blush%20tones&width=800&height=500&seq=article-newborn-sleep&orientation=landscape',
    author: '李医生',
    authorTitle: '儿科主治医师',
    readTime: 8,
    publishDate: '2025-12-15',
    tags: ['新生儿', '睡眠', '作息规律'],
    featured: true,
  },
  {
    id: 2,
    slug: 'umbilical-cord-care',
    title: '新生儿脐带护理：新手妈妈必知的五个关键点',
    excerpt: '脐带护理是新生儿时期最重要的事项之一。正确的护理方法可以有效预防感染，保障宝宝的健康。',
    content: `<p>脐带是连接妈妈和宝宝的"生命线"，出生后被剪断后，留在宝宝身上的脐带残端需要正确的护理。</p>
<h2>脐带脱落的时间</h2>
<p>正常情况下，脐带残端会在出生后1-3周内自然脱落。在脱落前，保持脐带区域的清洁和干燥至关重要。</p>
<h2>护理五大关键点</h2>
<h3>1. 保持干燥</h3>
<p>洗澡时避免脐带沾水，可以用防水贴保护。如果不小心弄湿了，用干净柔软的棉签轻轻吸干。</p>
<h3>2. 正确消毒</h3>
<p>每天用75%医用酒精棉签从脐带根部向外螺旋式消毒，每次使用新的棉签，不要来回擦拭。</p>
<h3>3. 选择合适衣物</h3>
<p>穿宽松的衣物，尿布要折在脐带下方，避免摩擦和闷热。</p>
<h3>4. 观察异常信号</h3>
<p>如果发现脐带周围红肿、有脓性分泌物、有臭味或宝宝发烧，应立即就医。</p>
<h3>5. 脱落后的护理</h3>
<p>脐带脱落后，可能会有少量渗血，继续用酒精消毒几天，直到完全干燥愈合。</p>
<h2>特别提醒</h2>
<p>千万不要用手去拉扯未脱落的脐带，让它自然脱落。也不要使用紫药水、红药水等有色消毒液，以免影响观察。</p>`,
    category: 'newborn-care',
    categoryName: '新生儿护理',
    image: 'https://readdy.ai/api/search-image?query=Soft%20gentle%20closeup%20of%20newborn%20baby%20tummy%20with%20mother%20caring%20hands%2C%20warm%20natural%20light%2C%20minimal%20neutral%20nursery%20background%2C%20clean%20aesthetic%2C%20professional%20editorial%20parenting%20photography%20with%20cream%20and%20beige%20tones&width=800&height=500&seq=article-umbilical&orientation=landscape',
    author: '王护士长',
    authorTitle: '产科资深护士',
    readTime: 5,
    publishDate: '2025-12-10',
    tags: ['新生儿', '脐带护理', '日常护理'],
    featured: false,
  },
  {
    id: 3,
    slug: 'postpartum-diet-guide',
    title: '产后恢复饮食指南：科学坐月子的营养搭配',
    excerpt: '产后饮食不仅关系到妈妈的恢复，还影响母乳质量。科学的月子餐应该如何搭配？',
    content: `<p>"坐月子"是中国传统的产后恢复方式，饮食调理是其中最重要的一环。现代医学也证实，产后合理的营养摄入对妈妈的身体恢复和母乳质量至关重要。</p>
<h2>产后饮食四大原则</h2>
<h3>1. 均衡营养，多样搭配</h3>
<p>不要只喝小米粥和鸡汤。产后需要全面的营养，应包含优质蛋白、复合碳水、健康脂肪、维生素和矿物质。</p>
<h3>2. 循序渐进，分段调理</h3>
<p>产后第一周以排恶露、消水肿为主；第二周以收缩子宫、调理气血为主；第三四周才开始温补。</p>
<h3>3. 多喝汤水，保证泌乳</h3>
<p>每天摄入不少于2000ml液体，包括汤、水、牛奶等。鲫鱼汤、猪蹄汤、木瓜汤都是不错的选择。</p>
<h3>4. 避免寒凉和刺激性食物</h3>
<p>避免生冷食物、辛辣食物、咖啡因和酒精，这些可能通过母乳影响宝宝。</p>
<h2>推荐食材清单</h2>
<p><strong>蛋白质来源：</strong>鸡蛋、鱼肉、瘦猪肉、鸡肉、豆腐</p>
<p><strong>补铁食物：</strong>猪肝、红枣、菠菜、黑木耳</p>
<p><strong>催乳食材：</strong>鲫鱼、猪蹄、花生、木瓜</p>
<p><strong>补钙食物：</strong>牛奶、芝麻、虾皮、西兰花</p>
<h2>一日参考食谱</h2>
<p>早餐：小米红枣粥 + 蒸蛋</p>
<p>加餐：牛奶 + 核桃</p>
<p>午餐：米饭 + 清蒸鱼 + 炒时蔬 + 排骨汤</p>
<p>加餐：红豆汤</p>
<p>晚餐：杂粮饭 + 鸡肉炒木耳 + 番茄蛋汤</p>
<p>加餐：木瓜炖奶</p>`,
    category: 'postpartum-recovery',
    categoryName: '产后恢复',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20nourishing%20Chinese%20postpartum%20confinement%20meal%20with%20warm%20soup%20and%20colorful%20nutritious%20dishes%20on%20wooden%20table%2C%20soft%20natural%20light%2C%20warm%20cream%20and%20terracotta%20color%20palette%2C%20cozy%20home%20kitchen%20aesthetic%2C%20editorial%20food%20photography&width=800&height=500&seq=article-postpartum-diet&orientation=landscape',
    author: '陈营养师',
    authorTitle: '注册营养师',
    readTime: 7,
    publishDate: '2025-12-08',
    tags: ['产后恢复', '月子餐', '饮食营养'],
    featured: true,
  },
  {
    id: 4,
    slug: 'pelvic-floor-recovery',
    title: '产后盆底肌修复：别让"笑尿了"成为你的困扰',
    excerpt: '产后漏尿是很多妈妈的难言之隐。科学的盆底肌修复训练，帮你重拾自信。',
    content: `<p>很多妈妈在产后会遇到一个尴尬的问题——咳嗽、打喷嚏、大笑时会不自主地漏尿。这不是"正常的"，是可以改善和治愈的。</p>
<h2>什么是盆底肌？</h2>
<p>盆底肌就像一张"吊床"，支撑着膀胱、子宫和直肠。怀孕和分娩会对盆底肌造成不同程度的损伤。</p>
<h2>盆底肌修复的黄金时间</h2>
<p>产后42天到6个月是盆底肌修复的黄金期，但任何时候开始都不晚。建议产后42天复查时进行盆底功能评估。</p>
<h2>凯格尔运动：盆底肌训练的基础</h2>
<h3>找到盆底肌</h3>
<p>尝试在排尿时突然中断尿流，用到的就是盆底肌。注意：这只是用来找感觉，不要经常在排尿时练习。</p>
<h3>正确的训练方法</h3>
<p>收紧盆底肌，保持3-5秒，然后放松3-5秒。重复10-15次为一组，每天做3组。</p>
<h3>常见错误</h3>
<p>不要收缩腹部、大腿或臀部肌肉，专注于盆底肌的独立运动。呼吸要自然，不要憋气。</p>
<h2>进阶训练</h2>
<p>当基础的凯格尔运动熟练后，可以尝试在不同体位下训练，或者结合日常活动（如提重物时先收紧盆底肌）。</p>
<p>如果自我训练效果不佳，请咨询专业的产后康复师，可能需要生物反馈或电刺激等辅助治疗。</p>`,
    category: 'postpartum-recovery',
    categoryName: '产后恢复',
    image: 'https://readdy.ai/api/search-image?query=Young%20mother%20doing%20gentle%20yoga%20stretching%20exercises%20on%20a%20soft%20mat%20in%20a%20bright%20airy%20living%20room%2C%20peaceful%20morning%20light%2C%20minimal%20decor%2C%20warm%20cream%20and%20sage%20green%20color%20scheme%2C%20lifestyle%20wellness%20photography&width=800&height=500&seq=article-pelvic-floor&orientation=landscape',
    author: '赵康复师',
    authorTitle: '产后康复专家',
    readTime: 6,
    publishDate: '2025-12-05',
    tags: ['产后恢复', '盆底肌', '凯格尔运动'],
    featured: false,
  },
  {
    id: 5,
    slug: 'breastfeeding-positions',
    title: '母乳喂养四大姿势详解：找到最适合你的方式',
    excerpt: '正确的哺乳姿势不仅能让宝宝吃得舒服，还能有效预防乳头皲裂和乳腺炎。',
    content: `<p>很多新手妈妈以为母乳喂养是"天生就会"的事情，但实际上，正确的哺乳姿势需要学习和练习。</p>
<h2>四大经典哺乳姿势</h2>
<h3>1. 摇篮式（最常用）</h3>
<p>宝宝的头枕在你的臂弯里，用同侧手臂支撑宝宝的身体。适合足月顺产的宝宝和妈妈。</p>
<p>要点：宝宝的肚子贴着妈妈的肚子，头、颈、身体呈一条直线。</p>
<h3>2. 交叉摇篮式</h3>
<p>用对侧手臂支撑宝宝，另一只手托住乳房。这个姿势让你能更好地控制宝宝的头部，适合新生儿和学习衔乳的宝宝。</p>
<h3>3. 橄榄球式</h3>
<p>宝宝放在身体侧面，像夹橄榄球一样夹在手臂下。适合剖宫产妈妈（避免压到伤口）、双胞胎妈妈、乳房较大的妈妈。</p>
<h3>4. 侧躺式</h3>
<p>妈妈和宝宝面对面侧躺。适合夜间哺乳和剖宫产恢复期，也是最省力的姿势。</p>
<h2>正确衔乳的五个步骤</h2>
<p>1. 用乳头轻触宝宝的嘴唇，等他自己张大嘴</p>
<p>2. 当嘴张到最大时，快速将宝宝拉向乳房</p>
<p>3. 宝宝的下巴先接触乳房</p>
<p>4. 嘴唇向外翻，像小鱼嘴</p>
<p>5. 面颊鼓圆，能听到吞咽声</p>
<h2>判断宝宝是否吃饱的指标</h2>
<p>每天换6-8片湿尿布，大便颜色从黑色胎便过渡到黄色奶便，体重稳步增长，哺乳后乳房变软、宝宝满足入睡。</p>`,
    category: 'breastfeeding',
    categoryName: '母乳喂养',
    image: 'https://readdy.ai/api/search-image?query=Gentle%20close-up%20silhouette%20of%20mother%20breastfeeding%20baby%20in%20a%20cozy%20nursery%20with%20soft%20diffused%20window%20light%2C%20warm%20cream%20interior%2C%20intimate%20and%20serene%20atmosphere%2C%20artistic%20lifestyle%20motherhood%20photography%20with%20beige%20and%20blush%20tones&width=800&height=500&seq=article-breastfeeding-positions&orientation=landscape',
    author: '林老师',
    authorTitle: '国际认证泌乳顾问',
    readTime: 7,
    publishDate: '2025-12-01',
    tags: ['母乳喂养', '哺乳姿势', '衔乳'],
    featured: true,
  },
  {
    id: 6,
    slug: 'breast-milk-storage',
    title: '母乳储存完全指南：背奶妈妈的必备手册',
    excerpt: '产假结束后重返职场，如何正确储存和加热母乳？这份指南为你解答所有疑问。',
    content: `<p>很多妈妈在产假结束后需要重返职场，但希望继续给宝宝母乳喂养。掌握正确的母乳储存方法，让"背奶"变得轻松。</p>
<h2>母乳储存容器选择</h2>
<p><strong>储奶袋：</strong>最适合冷冻储存，节省空间，一次性使用卫生方便。</p>
<p><strong>储奶瓶：</strong>适合短期冷藏，可重复使用，但要确保密封性良好。</p>
<p>无论哪种容器，都要标明日期和时间。</p>
<h2>母乳储存时间指南</h2>
<p><strong>室温（25°C以下）：</strong>4小时</p>
<p><strong>冷藏（4°C）：</strong>3-5天</p>
<p><strong>冷冻（-18°C）：</strong>3-6个月</p>
<p><strong>深冻（-20°C以下）：</strong>6-12个月</p>
<h2>正确解冻和加热方法</h2>
<p>1. 提前将冷冻母乳放入冷藏室解冻（约12小时）</p>
<p>2. 或放在流动的冷水下解冻</p>
<p>3. 用40°C左右的温水加热</p>
<p>❌ 不要用微波炉加热</p>
<p>❌ 不要直接在炉火上加热</p>
<p>❌ 解冻后的母乳不可再次冷冻</p>
<h2>辨别变质的母乳</h2>
<p>正常的母乳可能有淡淡的肥皂味或金属味，分离出奶脂层是正常的。但如果闻到明显的酸臭味，说明已经变质，应该丢弃。</p>`,
    category: 'breastfeeding',
    categoryName: '母乳喂养',
    image: 'https://readdy.ai/api/search-image?query=Organized%20breast%20milk%20storage%20bags%20neatly%20labeled%20in%20refrigerator%2C%20clean%20modern%20kitchen%20setting%2C%20bright%20natural%20light%2C%20minimal%20aesthetic%2C%20warm%20cream%20and%20white%20color%20palette%2C%20professional%20editorial%20photography&width=800&height=500&seq=article-milk-storage&orientation=landscape',
    author: '林老师',
    authorTitle: '国际认证泌乳顾问',
    readTime: 5,
    publishDate: '2025-11-28',
    tags: ['母乳喂养', '母乳储存', '背奶'],
    featured: false,
  },
  {
    id: 7,
    slug: 'baby-sensory-play',
    title: '0-6个月宝宝感官游戏大全：在家就能做的早教',
    excerpt: '宝宝的感官发育在出生后飞速进行。这些简单有趣的感官游戏，在家就能轻松开展。',
    content: `<p>宝宝的早期感官刺激对大脑发育至关重要。0-6个月是感官发展的关键期，不需要昂贵的早教课程，在家就能做很多有意义的游戏。</p>
<h2>视觉游戏</h2>
<h3>黑白卡（0-3个月）</h3>
<p>新生儿的视力只能看到20-30厘米远，对黑白对比最敏感。拿着黑白卡在宝宝眼前缓慢移动，每次1-2分钟。</p>
<h3>彩色玩具追踪（3-6个月）</h3>
<p>用颜色鲜艳的玩具在宝宝眼前慢慢移动，观察宝宝是否能追视。这锻炼眼部肌肉和注意力。</p>
<h2>听觉游戏</h2>
<h3>声音来源寻找</h3>
<p>在宝宝不同方位轻轻摇铃，观察他是否会转头寻找声源。这锻炼听觉定位能力。</p>
<h3>妈妈的歌声</h3>
<p>妈妈的声音是宝宝最熟悉的。经常唱歌、说话给宝宝听，促进语言中枢发育。</p>
<h2>触觉游戏</h2>
<h3>不同材质触摸</h3>
<p>准备丝绸、棉布、毛绒、软刷等不同材质的物品，轻轻触碰宝宝的手和脚，丰富触觉体验。</p>
<h3>婴儿按摩</h3>
<p>每天洗澡后做5-10分钟婴儿抚触，不仅能促进触觉发育，还能增进亲子情感。</p>
<h2>运动游戏</h2>
<h3>俯卧练习</h3>
<p>每天多次短时间俯卧，锻炼颈部、背部和上肢力量，为翻身和爬行做准备。</p>
<h3>蹬腿游戏</h3>
<p>轻轻推宝宝的小脚，鼓励他用力蹬回来，锻炼腿部力量和协调性。</p>`,
    category: 'early-education',
    categoryName: '宝宝早教',
    image: 'https://readdy.ai/api/search-image?query=Cute%20baby%20reaching%20for%20colorful%20montessori%20sensory%20toys%20on%20a%20soft%20play%20mat%20in%20a%20bright%20minimalist%20living%20room%2C%20gentle%20natural%20morning%20light%2C%20warm%20beige%20and%20soft%20pastel%20color%20scheme%2C%20lifestyle%20parenting%20photography&width=800&height=500&seq=article-sensory-play&orientation=landscape',
    author: '张早教师',
    authorTitle: '儿童早期教育专家',
    readTime: 6,
    publishDate: '2025-11-25',
    tags: ['宝宝早教', '感官游戏', '0-6个月'],
    featured: true,
  },
  {
    id: 8,
    slug: 'baby-language-development',
    title: '宝宝语言发育里程碑：0-2岁各阶段应该注意什么',
    excerpt: '从第一声啼哭到说出完整句子，了解宝宝语言发育的关键节点，及时发现问题。',
    content: `<p>语言发育是宝宝早期发展的重要指标之一。了解各阶段的语言发育里程碑，可以帮助妈妈及时发现和干预可能的发育迟缓。</p>
<h2>0-3个月：声音的启蒙</h2>
<p>对声音有反应，会安静下来或微笑回应妈妈的声音。发出"咕咕"声和元音类声音("啊""哦")。</p>
<h2>4-6个月：牙牙学语</h2>
<p>开始发出有节奏的咿呀声，如"ba-ba""da-da"。对不同语气有反应，能通过声音表达开心或不开心。</p>
<h2>7-12个月：理解开始萌芽</h2>
<p>能理解简单的词语如"不"、"拜拜"。开始模仿声音和手势，可能会说出第一个有意义的词（通常是"妈妈"或"爸爸"）。</p>
<h2>12-18个月：词汇爆发期</h2>
<p>能说3-20个单词，能指出身体部位，理解简单的指令。18个月左右可能出现"词汇爆发"，每周学会新词。</p>
<h2>18-24个月：简单句子</h2>
<p>能用两个词组成简单句子，如"妈妈抱"。能说出50个以上的词，开始使用"我""你"。</p>
<h2>促进语言发育的小技巧</h2>
<p>1. 多和宝宝"对话"，即使他还不会回应</p>
<p>2. 描述你正在做的事情</p>
<p>3. 读绘本，这是语言启蒙最好的方式</p>
<p>4. 扩展宝宝的话，他说"球"，你可以说"对，这是一个红色的球"</p>
<p>5. 减少屏幕时间，真人互动最重要</p>`,
    category: 'early-education',
    categoryName: '宝宝早教',
    image: 'https://readdy.ai/api/search-image?query=Mother%20reading%20a%20colorful%20children%20picture%20book%20to%20her%20baby%20on%20a%20cozy%20sofa%2C%20warm%20afternoon%20sunlight%20streaming%20through%20window%2C%20minimal%20Scandinavian%20interior%2C%20cream%20and%20soft%20earth%20tones%2C%20heartwarming%20parenting%20moment&width=800&height=500&seq=article-language-dev&orientation=landscape',
    author: '张早教师',
    authorTitle: '儿童早期教育专家',
    readTime: 5,
    publishDate: '2025-11-20',
    tags: ['宝宝早教', '语言发育', '里程碑'],
    featured: false,
  },
  {
    id: 9,
    slug: 'mom-self-care',
    title: '当了妈妈后，别忘了好好爱自己：新手妈妈的自我关怀指南',
    excerpt: '很多妈妈把全部精力放在了宝宝身上，却忽略了自己的需求。学会自我关怀，才能成为更好的妈妈。',
    content: `<p>成为妈妈是人生中最美好的经历之一，但也可能是最具挑战性的。在照顾宝宝的忙碌中，很多妈妈不知不觉地忽略了自己。</p>
<h2>为什么自我关怀如此重要？</h2>
<p>就像一个空杯子无法倒出水来，一个精疲力竭的妈妈很难给予宝宝高质量的陪伴。自我关怀不是自私，是对自己和家庭负责。</p>
<h2>五个简单可行的自我关怀方法</h2>
<h3>1. 每天给自己15分钟</h3>
<p>无论是泡一杯好茶、读几页书、还是简单地闭眼冥想，每天给自己一段完全属于自己的时间。</p>
<h3>2. 保持社交连接</h3>
<p>加入妈妈群、和老朋友保持联系、偶尔约个下午茶。不要让自己陷入"只有宝宝"的社交孤岛。</p>
<h3>3. 适当运动</h3>
<p>产后6周后，可以从散步开始，逐渐增加运动量。运动释放的内啡肽是天然的情绪调节剂。</p>
<h3>4. 接受不完美</h3>
<p>没有完美的妈妈，允许自己犯错。宝宝需要一个真实的、快乐的妈妈，而不是一个完美的机器人。</p>
<h3>5. 寻求帮助</h3>
<p>向伴侣、家人、朋友求助不是什么丢脸的事。如果你持续感到情绪低落、焦虑、失眠，请勇敢地寻求专业帮助。</p>
<h2>警惕产后抑郁的信号</h2>
<p>如果以下症状持续超过两周，建议咨询心理医生：持续的情绪低落、对宝宝缺乏兴趣、严重的睡眠问题、食欲显著改变、有伤害自己或宝宝的想法。</p>`,
    category: 'mom-growth',
    categoryName: '妈妈成长',
    image: 'https://readdy.ai/api/search-image?query=Young%20mother%20enjoying%20a%20peaceful%20moment%20with%20a%20cup%20of%20tea%20by%20the%20window%2C%20warm%20afternoon%20light%2C%20minimal%20cozy%20home%20interior%20with%20plants%2C%20serene%20and%20calm%20atmosphere%2C%20cream%20and%20soft%20blush%20color%20palette%2C%20lifestyle%20wellness%20photography&width=800&height=500&seq=article-mom-self-care&orientation=landscape',
    author: '刘心理咨询师',
    authorTitle: '国家二级心理咨询师',
    readTime: 6,
    publishDate: '2025-11-15',
    tags: ['妈妈成长', '自我关怀', '心理健康'],
    featured: true,
  },
  {
    id: 10,
    slug: 'mom-time-management',
    title: '新手妈妈的时间管理：在带娃间隙找到自己的节奏',
    excerpt: '当了妈妈后，时间仿佛永远不够用。学会高效时间管理，在忙碌的育儿生活中找到属于自己的空间。',
    content: `<p>"有了宝宝后，我连上厕所的时间都没有了。"这可能是很多新手妈妈的心声。但好的时间管理确实可以帮助你在育儿生活中找到一丝喘息的空间。</p>
<h2>接受新的时间节奏</h2>
<p>首先要认识到：有宝宝后的生活就是碎片化的。与其抗拒，不如适应。把"整块时间"的期待调整为"碎片时间"的利用。</p>
<h2>四象限时间管理法</h2>
<p>把要做的事情分为四类：</p>
<p><strong>重要且紧急：</strong>宝宝饿了要喂奶、换尿布——立刻做</p>
<p><strong>重要不紧急：</strong>产后康复训练、学习育儿知识——安排时间做</p>
<p><strong>不重要但紧急：</strong>某些社交消息回复——可以快速处理或委派</p>
<p><strong>不重要不紧急：</strong>刷社交媒体——尽量减少</p>
<h2>实用时间管理技巧</h2>
<h3>利用宝宝睡眠时间</h3>
<p>宝宝睡觉时，优先做对自己最重要的事，而不是家务。可以先休息、阅读、或者做15分钟瑜伽。</p>
<h3>建立日常规律</h3>
<p>虽然宝宝的作息有时不可预测，但可以建立一个大致的日常框架，减少决策疲劳。</p>
<h3>学会"足够好"</h3>
<p>家务不需要做到100分，80分就够了。把省下的时间和精力留给自己。</p>
<h3>和伴侣分工</h3>
<p>坦诚沟通，明确分工。不要觉得"只有我能做好"，放手让伴侣参与育儿。</p>`,
    category: 'mom-growth',
    categoryName: '妈妈成长',
    image: 'https://readdy.ai/api/search-image?query=Young%20mother%20using%20a%20notebook%20planner%20while%20baby%20plays%20nearby%20on%20a%20soft%20play%20mat%2C%20organized%20minimalist%20living%20room%2C%20warm%20morning%20light%2C%20cream%20and%20terracotta%20color%20tone%2C%20calm%20productive%20lifestyle%20photography&width=800&height=500&seq=article-time-management&orientation=landscape',
    author: '刘心理咨询师',
    authorTitle: '国家二级心理咨询师',
    readTime: 5,
    publishDate: '2025-11-10',
    tags: ['妈妈成长', '时间管理', '生活平衡'],
    featured: false,
  },
];

export const faqs = [
  {
    question: '新生儿一天应该喂几次奶？',
    answer: '新生儿期（0-28天）应按需喂养，通常每天8-12次。母乳消化快，宝宝饿了就喂，不要严格按时喂养。观察宝宝的饥饿信号（咂嘴、转头找乳头、吸吮手指），而不是等到哭了再喂。',
  },
  {
    question: '产后多久可以开始运动？',
    answer: '顺产妈妈产后2-3天可以从散步开始，产后6周可以逐渐恢复常规运动。剖宫产妈妈建议产后8-12周再开始运动。无论哪种分娩方式，开始运动前最好咨询医生。',
  },
  {
    question: '母乳不够怎么办？',
    answer: '首先确认是否真的不够：如果宝宝每天有6-8片湿尿布，体重正常增长，说明奶量充足。确实不够的话，可以增加喂奶频率（多吸吮刺激泌乳）、保证妈妈营养和水分摄入、充分休息、保持愉悦心情。必要时咨询泌乳顾问。',
  },
  {
    question: '宝宝多大可以开始早教？',
    answer: '早教从出生就可以开始！0-6个月的早教重点是感官刺激和亲子互动：多和宝宝说话、唱歌、做抚触、俯卧练习、看黑白卡等。早期教育的核心不是"教知识"，而是通过丰富的互动促进大脑发育。',
  },
  {
    question: '产后情绪低落多久算正常？',
    answer: '产后情绪低落（Baby Blues）通常在产后3-5天出现，持续不超过2周，症状较轻，不需要特殊治疗。如果情绪低落持续超过2周，或伴有严重的焦虑、失眠、对宝宝缺乏兴趣等症状，可能是产后抑郁，建议尽快寻求专业帮助。',
  },
  {
    question: '如何判断宝宝是否发烧？应该怎么处理？',
    answer: '3个月以下宝宝肛温≥38°C即为发烧，需立即就医。3个月以上宝宝体温38°C以下可以观察，多喂奶补充水分、减少衣物、保持室内通风。38.5°C以上可按医嘱使用退烧药。任何月龄宝宝出现精神萎靡、拒食、抽搐等情况都要立即就医。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小美妈妈',
    babyAge: '宝宝8个月',
    content: '作为一个新手妈妈，这个网站真的帮了我太多。特别是那篇新生儿睡眠的文章，按照里面的方法做了两周，宝宝终于能睡整觉了！',
    rating: 5,
  },
  {
    id: 2,
    name: '阳阳妈',
    babyAge: '宝宝1岁2个月',
    content: '产后恢复的内容特别实用，盆底肌修复的文章让我意识到这个问题不能拖。现在已经坚持做了两个月的凯格尔运动，效果很明显。',
    rating: 5,
  },
  {
    id: 3,
    name: '朵朵妈妈',
    babyAge: '宝宝6个月',
    content: '最喜欢妈妈成长板块，让我意识到不能只做"某某妈妈"，还要做我自己。时间管理的文章让我重新找到了生活的节奏。',
    rating: 5,
  },
  {
    id: 4,
    name: '小宇妈',
    babyAge: '双胞胎4个月',
    content: '母乳喂养的文章给了我很大的信心！双胞胎母乳喂养真的很难，但按着文章里的方法坚持下来，现在已经实现全母乳了。',
    rating: 5,
  },
];